import { Property } from "csstype"
import { styled, StyleProps, CSS } from "../../../styles"

interface CircleProps {
  color?: Property.Color
}

type Props = StyleProps & CircleProps

export const CircleMarker = styled.span(
  (props: Props): CSS => ({
    display: `inline-block`,
    borderRadius: `100%`,
    background: props.color,
    width: `18px`,
    height: `18px`,
    marginRight: `8px`,
  })
)

CircleMarker.defaultProps = {
  color: undefined,
}
